export function getCommonRequestHeaders() {
  return {};
}
